/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { UserIndustryMaster, UserIndustryMasterApi } from "@/apis/clients";
import { wrap } from "@/apis/wrap";

const userIndustryMasterApi = {
  getUserIndustries: wrap(
    UserIndustryMasterApi,
    UserIndustryMasterApi.prototype.getUserIndustries,
  ),
};

/**
 * 「その他」の業種であるか
 * MEMO: IDで比較するのが確実だが、不明なため一旦文字列比較とする
 * @param industry
 */
export function isOtherIndustry(industry: UserIndustryMaster): boolean {
  return industry.industry_name === "その他";
}

export default userIndustryMasterApi;
